import React from 'react'

const ModalFooter = (props) => {
    const { children, cssClass, style } = props
    return (
        <div style={style} className={`modalFooter ${cssClass || ''}`}>
            {children}
        </div>
    )
}

export default ModalFooter
